// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_02712f2b3b--wrapper--uVUff","label":"_02712f2b3b--label--f3D7V"};